 <template> 
  <!-- Contact -->
  <div class="w3-container" id="contact" style="margin-top:75px">
    <h1 class="w3-xxxlarge w3-text-blue"><b>Contact.</b></h1>
    <hr style="width:50px;border:5px solid blue" class="w3-round">
    <p>Do you want a free consult to learn what we can do for your business? Contact us and let us know what your business objectives are.</p>
    <form action="mailto:hello@mkserverless.com?Subject=Free Consult Inquiry" enctype="text/plain" method="POST">
      
      <div class="w3-section">
        <label>Name</label>
        <input class="w3-input w3-border" type="text" name="Name" required>
      </div>
      <div class="w3-section">
        <label>Email</label>
        <input class="w3-input w3-border" type="text" name="Email" required>
      </div>
      <div class="w3-section">
        <label>Message</label>
        <input class="w3-input w3-border" type="text" name="Message" required>
      </div>
    
      <button type="submit" class="w3-button w3-block w3-padding-large w3-blue w3-margin-bottom">Send Email</button>
    </form>  
  </div>
</template>
 <script>
export default {
    name: 'Contact'
};
</script> 